import type { IntlKey } from 'locales';
import type { GimmickName } from 'models/forms/fields';
import { FC } from 'react';

import { LabelGimmickItem } from './LabelGimmickItem';

interface SwitchItemProps {
  value: GimmickName;

  labelKey: IntlKey;

  isSelected: boolean;

  onCheckboxChanged: (value: GimmickName, isSelected: boolean) => void;
}

export const GimmickItem: FC<SwitchItemProps> = ({ value, labelKey, onCheckboxChanged, isSelected }) => {
  const id = `gimmickSwitch.${value}`;
  const onChange = () => onCheckboxChanged(value, !isSelected);

  return (
    <li className="list-group-item border-light px-0 my-1">
      <div className="d-flex justify-space-between align-items-center">
        <LabelGimmickItem labelKey={labelKey} gimmick={value} />
        <div className="ms-auto form-check form-switch form-check-edited float-end">
          <input type="checkbox" className="form-check-input" id={id} onChange={onChange} checked={isSelected} />
          <label className="form-check-label" htmlFor={id}></label>
        </div>
      </div>
    </li>
  );
};
